// Copy Template Modal Actions
export const GET_COPY_MODAL_CONTEXT_DATA = 'GET_COPY_MODAL_CONTEXT_DATA';
export const GETTING_COPY_MODAL_CONTEXT_DATA = 'GETTING_COPY_MODAL_CONTEXT_DATA';
export const GETTING_COPY_MODAL_CONTEXT_DATA_SUCCEEDED = 'GETTING_COPY_MODAL_CONTEXT_DATA_SUCCEEDED';
export const GETTING_COPY_MODAL_CONTEXT_DATA_FAILED = 'GETTING_COPY_MODAL_CONTEXT_DATA_FAILED';

export const GET_COPY_MODAL_SUPPORTED_EVENT_TYPES = 'GET_COPY_MODAL_SUPPORTED_EVENT_TYPES';
export const GETTING_COPY_MODAL_SUPPORTED_EVENT_TYPES = 'GETTING_COPY_MODAL_SUPPORTED_EVENT_TYPES';
export const GETTING_COPY_MODAL_SUPPORTED_EVENT_TYPES_SUCCEEDED = 'GETTING_COPY_MODAL_SUPPORTED_EVENT_TYPES_SUCCEEDED';
export const GETTING_COPY_MODAL_SUPPORTED_EVENT_TYPES_FAILED = 'GETTING_COPY_MODAL_SUPPORTED_EVENT_TYPES_FAILED';

export const RESET_COPY_MODAL_STORE = 'RESET_COPY_MODAL_STORE';

// Action creators
export const getCopyModalContextData = (businessContextId, force = false) => ({
  type: GET_COPY_MODAL_CONTEXT_DATA,
  payload: { businessContextId },
  force
});

export const gettingCopyModalContextData = () => ({
  type: GETTING_COPY_MODAL_CONTEXT_DATA
});

export const gettingCopyModalContextDataSucceeded = (data) => ({
  type: GETTING_COPY_MODAL_CONTEXT_DATA_SUCCEEDED,
  payload: data
});

export const gettingCopyModalContextDataFailed = (error) => ({
  type: GETTING_COPY_MODAL_CONTEXT_DATA_FAILED,
  payload: error
});

export const getSupportedEventTypes = (payload) => ({
  type: GET_COPY_MODAL_SUPPORTED_EVENT_TYPES,
  payload
});

export const gettingSupportedEventTypes = () => ({
  type: GETTING_COPY_MODAL_SUPPORTED_EVENT_TYPES
});

export const gettingSupportedEventTypesSucceeded = (data) => ({
  type: GETTING_COPY_MODAL_SUPPORTED_EVENT_TYPES_SUCCEEDED,
  payload: data
});

export const gettingSupportedEventTypesFailed = (error) => ({
  type: GETTING_COPY_MODAL_SUPPORTED_EVENT_TYPES_FAILED,
  payload: error
});

export const resetCopyModalStore = () => ({
  type: RESET_COPY_MODAL_STORE
});